import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_chart-line",
  "use": "svg_chart-line-usage",
  "viewBox": "0 0 165 82",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 82\" id=\"svg_chart-line\"><path d=\"m0 79 17.267-3.888a32 32 0 0 0 16.909-9.982l3.731-4.206a29.9 29.9 0 0 1 19.356-9.905v0a29.9 29.9 0 0 0 19.426-9.985l10.973-12.458c6.673-7.577 18.587-7.232 24.811.719v0c5.727 7.317 16.436 8.295 23.395 2.138L168 3\" stroke=\"#fff\" stroke-width=\"6\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol